<template>
  <div class="container">
    <b-card @submit="onSubmit" @reset="onReset" class="row">
      <h2>Callbacks Filter</h2>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <b-row class="my-1">
          <b-col md="4">
            <label for="callbackUser">User</label>
          </b-col>
          <b-col md="4">
            <b-form-select v-if="lookups"
                           id="callbackUser"
                           v-model="searchFilter.callbackUser"
                           :options="lookups.callbackUsers"
                           value-field="id"
                           text-field="fullName"></b-form-select>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col md="4">
            <label for="callbackDate">Callback Date Due</label>
          </b-col>
          <b-col md="4">
            <b-form-select id="callbackUser"
                           v-model="searchFilter.callbackDue"
                           :options="this.callbackDue"
                           value-field="id"
                           text-field="name"></b-form-select>
          </b-col>
          <b-form-checkbox v-model="searchFilter.includeToday">
            Include Today
          </b-form-checkbox>
        </b-row>

        <b-row class="my-1">
          <b-col md="4">
            <label for="callbackDate">Callback From/To</label>
          </b-col>
          <b-col md="4">
            <b-form-datepicker id="callbackFrom"
                               v-model="searchFilter.callbackFrom"
                               :date-format-options="{
                                  year: 'numeric',
                                  month: 'numeric',
                                  day: 'numeric',
                                }"
                               locale="en-GB"
                               reset-button></b-form-datepicker>
          </b-col>
          <b-col md="4">
            <b-form-datepicker id="callbackTo"
                               v-model="searchFilter.callbackTo"
                               :date-format-options="{
                         year: 'numeric',
                         month: 'numeric',
                         day: 'numeric',
                       }"
                               locale="en-GB"
                               reset-button></b-form-datepicker>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col md="4">
            <label for="callbackDays">Callback Days</label>
          </b-col>
          <b-col md="8">
            <multiselect v-model="searchFilter.callbackDays"
                         label="name"
                         track-by="id"
                         :options="callbackDays"
                         :multiple="true"
                         :hide-selected="true"></multiselect>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col md="4">
            <label for="callbackDays">Callback Priority</label>
          </b-col>
          <b-col md="8">
            <multiselect v-model="searchFilter.callbackPriorties"
                         label="name"
                         track-by="id"
                         :options="priorities"
                         :multiple="true"
                         :hide-selected="true"></multiselect>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col md="4">
            <label for="companyStatuses">Status</label>
          </b-col>
          <b-col md="8">
            <multiselect v-if="lookups"
                         v-model="searchFilter.statuses"
                         label="name"
                         track-by="id"
                         :options="lookups.companyStatuses"
                         :multiple="true"
                         :hide-selected="true"></multiselect>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col md="4">
            <label for="companyTiers">Tier</label>
          </b-col>
          <b-col md="8">
            <multiselect v-if="lookups"
                         v-model="searchFilter.companyTiers"
                         label="randdName"
                         track-by="id"
                         :options="lookups.companyTiers"
                         :multiple="true"
                         :hide-selected="true"></multiselect>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col md="4"> </b-col>
          <b-col md="6">
            <FeedbackButton style="margin-right: 16px" title="Search" icon="search" :busy="isBusy" :onClick="getCallbacks" />
            <b-button class="my-1"
                      variant="danger"
                      type="button"
                      @click="reset"><font-awesome-icon icon="times" />&nbsp;Cancel</b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <b-card class="row" v-if="searchResults.length > 0">
      <b-row class="my-3">
        <b-button class="my-1"
                  variant="success"
                  type="button"
                  style="margin-right: 16px"
                  @click="reassignAll"><font-awesome-icon icon="repeat" />&nbsp;Reassign All</b-button>
        &nbsp;&nbsp;
        <b-button class="my-1"
                  variant="success"
                  type="button"
                  @click="reassignSelected"><font-awesome-icon icon="repeat" />&nbsp;Reassign Selected</b-button>
      </b-row>
    </b-card>

    <div class="row" v-if="!searchResults || searchResults.length == 0">
      <div class="col-sm-12 margin-top">
        <b-alert show><strong>No Search Results</strong></b-alert>
      </div>
    </div>

    <b-card :title="'Search Results (' + this.rows + ')'" class="margin-bottom" v-if="searchResults && searchResults.length > 0">
      <div class="row" v-if="searchResults && searchResults.length > 0">

        <b-table striped
                 hover
                 :items="searchResults"
                 :fields="fields"
                 :current-page="currentPage"
                 :per-page="0"
                 :busy.sync="isBusy"
                 :sort-by.sync="sortBy"
                 :sort-desc.sync="sortDesc"
                 no-local-sorting
                 @sort-changed="sortingChanged">

          <template slot="head(transferId)">
            <b-form-checkbox v-model="toggleAll"></b-form-checkbox>
          </template>

          <template v-slot:cell(transferId)="data">
            <b-form-checkbox :value="data.item.id" v-model="searchFilter.transferIds"></b-form-checkbox>
          </template>

          <template v-slot:cell(company)="data">
            {{ data.item.companyName }}
            <br />
            {{ data.item.postcode }}
          </template>

          <template v-slot:cell(contact)="data">
            <div>
              {{ data.item.companyVendors[0].firstName }}
              {{ data.item.companyVendors[0].lastName }}
            </div>
            <div>
              {{ data.item.companyVendors[0].preferredContactNumber }}
            </div>
          </template>

          <template v-slot:cell(lastContacted)="data">
            {{ data.item.lastCallbackDatetime | formatDate  }}
          </template>

          <template v-slot:cell(callback)="data">
            {{ data.item.callbackDatetime | formatDate  }}
            <br />
            {{ data.item.callbackPriority.name }}
          </template>

          <template v-slot:cell(agent)="data">
            {{ data.item.callbackUser }}
          </template>

          <template v-slot:cell(nav)="data">
            <button class="details btn btn-danger btn-xs"
                    type="button"
                    @click="clearCallback(data.item.id)">
              <font-awesome-icon icon="times" /> Clear
            </button>
          </template>
        </b-table>

        <div class="col-sm-12">
          <b-alert :show="showNoResults">
            <strong>No Results.</strong> Search criteria found no results.
          </b-alert>
        </div>

        <b-pagination v-model="currentPage"
                      :total-rows="rows"
                      :per-page="10"
                      first-number
                      last-number></b-pagination>
      </div>
    </b-card>
    <TransferCallbackModal v-if="lookups"
                           ref="transferCallbackModal"
                           :users="lookups.callbackUsers"
                           :companyIds="modalTransferIds" />

    
  </div>
  
</template>

<script>
  import CallbackService from '@/services/Callback.service'
  import Multiselect from "vue-multiselect";
  //import LookupsService from '@/services/Lookups.service'
  import FeedbackButton from "@/components/shared/FeedbackButton.vue";
  import TransferCallbackModal from "@/components/admincallback/CallbackTransferModal.vue";

  export default {
    components: { Multiselect, FeedbackButton, TransferCallbackModal },
    props: ['newFilter', 'lookups'],
    data() {
      return {
        searchFilter: {
          callbackUser: null,
          callbackDue: null,
          includeToday: false,
          callbackFrom: null,
          callbackTo: null,
          callbackDays: [],
          callbackPriorties: null,
          statuses: null,
          companyTiers: null,
          transferIds: [],
        },
        callbackDue: [
          { id: 1, name: "Overdue" },
          { id: 2, name: "Future" },
        ],
        callbackDays: [
          { id: 1, name: "Monday" },
          { id: 2, name: "Tuesday" },
          { id: 3, name: "Wednesday" },
          { id: 4, name: "Thursday" },
          { id: 5, name: "Friday" },
        ],
        priorities: [
          { id: "10", name: "Low" },
          { id: "20", name: "Medium" },
          { id: "30", name: "High" },
        ],
        //lookups: null,
        fields: [
          { key: "transferId", label: "", sortable: false },
          { key: "company", label: "Company Name", sortable: true },
          { key: "contact", label: "Primary Contact", sortable: false },
          { key: "lastContacted", label: "Last Contacted", sortable: true },
          { key: "callback", label: "Callback Arranged/Priority", sortable: true },
          { key: "agent", label: "Agent", sortable: true },
          { key: "nav", label: "", sortable: false },
        ],
        currentPage: 1,
        rows: 0,
        isBusy: false,
        sortBy: "",
        sortDesc: false,
        searchResults: [],
        allSearchResults: [],
        sortColumn: 'company',
        sortDirection: 'ASC',
        toggleAll: false,
        modalTransferIds: [],
      }

    },
    //created() {
    //  LookupsService.loadLookups().then((result) => {
    //    this.lookups = result.data;
    //  });
    //},
    watch: {
      currentPage: {
        handler: function () {
          this.getCallbacks();
        }
      },
      toggleAll: {
        handler: function () {
          if (this.toggleAll) {
            this.searchFilter.transferIds = [];
            this.allSearchResults.forEach((r) => {
              
              this.searchFilter.transferIds.push(r);
            });
          }
          else {
            this.searchFilter.transferIds = [];
          }
          console.log(this.searchFilter.transferIds);
        }
      },
      newFilter: {
        handler: function () {
          this.searchFilter.callbackUser = this.newFilter.user;
          this.searchFilter.callbackPriorties = this.priorities.filter(x => x.id === this.newFilter.priority);
          this.searchFilter.callbackFrom = this.newFilter.selectedDate;
          this.searchFilter.callbackTo = this.newFilter.selectedDate;
          this.clickSearch();
        },
        deep: true
      }
    },
    
    methods: {
      onSubmit() {

      },
      onReset() {

      },
      clickSearch() {
        this.currentPage = 1;
        this.getCallbacks();
      },
      getCallbacks() {
        this.isBusy = true;

        var form = {
          callbackUser: this.searchFilter.callbackUser,
          callbackDue: this.searchFilter.callbackDue,
          includeToday: this.searchFilter.includeToday,
          callbackFrom: this.searchFilter.callbackFrom,
          callbackTo: this.searchFilter.callbackTo,
          callbackDays: this.searchFilter.callbackDays === null ? null : this.searchFilter.callbackDays.map(x => x.id),
          callbackPriorties: this.searchFilter.callbackPriorties === null ? null : this.searchFilter.callbackPriorties.map(x => x.id),
          statuses: this.searchFilter.statuses === null ? null : this.searchFilter.statuses.map(x => x.id),
          companyTiers: this.searchFilter.companyTiers === null ? null : this.searchFilter.companyTiers.map(x => x.id),
          sortColumn: this.sortColumn,
          sortDirection: this.sortDirection,
          page: this.currentPage
        }
        CallbackService.searchCallbacks(form).then((result) => {
          this.isBusy = false;
          this.searchResults = result.data.callbacks;
          this.allSearchResults = result.data.allIds;
          this.rows = result.data.totalResults;
          this.showNoResults = (result.data && result.data.callbacks.length == 0);

        }).catch(() => {
          this.isBusy = false;
        });
      },
      async sortingChanged(ctx) {
        console.log(ctx);
        this.currentPage = 1;
        this.sortDirection = ctx.sortDesc ? "ASC" : "DESC";
        this.sortColumn = ctx.sortBy;

        this.getCallbacks();
      },
      clearCallback(id) {
        console.log(id);
      },
      reset() {

      },
      reassignSelected() {
        if (this.searchFilter.transferIds.length > 0) {
          this.modalTransferIds = this.searchFilter.transferIds;
          this.$refs.transferCallbackModal.showModal()
        }
      },
      reassignAll() {
        if (this.allSearchResults.length > 0) {
          this.modalTransferIds = this.allSearchResults;
          this.$refs.transferCallbackModal.showModal()
        }
      },

    },

  }
</script>
